<template>
	<section class="fast_list">
  <transition-group v-if="minutes.length > 0" name="flip-list" tag="ul" :class="['my_list','minutes']">
    <li 
      v-for="(result,index) in minutes" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        >
        <div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
  <transition-group v-if="sameDay.length > 0" name="flip-list" tag="ul" :class="['my_list','same']">
    <li 
      v-for="(result,index) in sameDay" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        >
        <div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
  <transition-group v-if="nextDay.length > 0" name="flip-list" tag="ul" :class="['my_list','next']">
    <li 
      v-for="(result,index) in nextDay" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        >
        <div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
  <transition-group v-if="twoDays.length > 0" name="flip-list" tag="ul" :class="['my_list','two']">
    <li 
      v-for="(result,index) in twoDays" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        >
        <div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
  <transition-group v-if="plusThreeDays.length > 0" name="flip-list" tag="ul" :class="['my_list','plus']">
    <li 
      v-for="(result,index) in plusThreeDays" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        >
        <div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
</section>
</template>

<script>
	export default {
		data(){
			return{

			}
		},
		props:['sortedArray','getTransferScore','getLogoPsp','getTransferBar','virgule_rec','virgule','getPspLink','getPspName'],
		computed : {
		  minutes() {
            function time(element, index, array){
        	  return element.transfer_time_product_rate == 10; 
      		}
      		return this.sortedArray.filter(time);   
    	  },
    	  sameDay() {
            function time(element, index, array){
        	  return element.transfer_time_product_rate == 20; 
      		}
      		return this.sortedArray.filter(time);   
    	  },
    	  nextDay() {
            function time(element, index, array){
        	  return element.transfer_time_product_rate == 30; 
      		}
      		return this.sortedArray.filter(time);   
    	  },
    	  twoDays() {
            function time(element, index, array){
        	  return element.transfer_time_product_rate == 40; 
      		}
      		return this.sortedArray.filter(time);   
    	  },
    	  plusThreeDays() {
            function time(element, index, array){
        	  return element.transfer_time_product_rate == 50; 
      		}
      		return this.sortedArray.filter(time);   
    	  }
		}
	}

</script>

<style lang="scss" scoped>
	ul {
		margin-left: 16px;
		margin-right: 16px;
		border: 3px solid #E8E7E7;
		border-radius: 12px;
		margin-bottom: 32px;
		position: relative;

    li {
      padding-left: 17px;
      padding-right: 17px;
      padding-top: 0;
      padding-bottom: 0;
      .container {
        padding-left: 0;
        padding-right: 0;
      }
    }

		&:before {
			content:'';
			position: absolute;
			top: -10px;
			left: 20px;
			background: #fff;
			font-size: 13px;
			font-family: 'Avenir Next';
      		font-weight: 700;
      		letter-spacing: 0.035em;
			padding-left: 36px;
			padding-right: 16px;
			color: #4c4c4c;
			text-transform: uppercase;
			background-image: url('../assets/clock_fast.svg');
			background-position: 12px center;
			background-repeat: no-repeat;

		}

		&.minutes {
			border: 3px solid #78ca00;
			&:before {
				content:'In minutes';
				color: #77ca00;
				background-image: url('../assets/clock_fast_green.svg');
			}

      li:first-child {
        .container {
          overflow: visible;
        }
        .total_cost {

          background: #e6e6e64d;
          border-radius: 8px;
          padding-top: 20px;
          padding-bottom: 20px;

          &:after {
            display: none;  
          }

          &:before {
          content:'Total cost';
          top: -46px;
          font-size: 15px;
          position: absolute;
          display: inline-block;
          width: 130%;
          left: -15%;

        }
        }
      }
		}
		&.same {
			&:before {
				content:'Same day';
			}
		}
		&.next {
			&:before {
				content:'Next day';
			}
		}
		&.two {
			&:before {
				content:'Two days';
			}
		}
		&.plus {
			&:before {
				content:'3-5 days';
			}
		}
		li {

			&:first-child .container{
				padding-top: 17px;
			}

			&:last-child .container{
				padding-bottom: 17px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Fast.vue